import { TabValue } from '@/types';
import { Dispatch, ReactElement, SetStateAction, createContext, useState } from 'react';
import { DateType } from '@/components/tachograph/diagram/TachographService';

export type TachographContextType = {
  tab: TabValue;
  setTab: Dispatch<SetStateAction<TabValue>>;
  selectedDates: DateType | undefined;
  setSelectedDates: Dispatch<SetStateAction<DateType | undefined>>;
  searchText: string | undefined;
  setSearchText: Dispatch<SetStateAction<string | undefined>>;
  selectedRowIds: number[];
  setSelectedRowIds: Dispatch<SetStateAction<number[]>>;
  selectedRowCardNumbers: string[];
  setSelectedRowCardNumbers: Dispatch<SetStateAction<string[]>>;
  addressee: string | undefined;
  setAddressee: Dispatch<SetStateAction<string | undefined>>;
  isCroatian: boolean;
  setIsCroatian: Dispatch<SetStateAction<boolean>>;
};

export const ctxTachograph = createContext<TachographContextType | undefined>(undefined);

export function TachographContext({ children }: { children: ReactElement }) {
  const [tab, setTab] = useState<TabValue>(TabValue.targetSelect);
  const [selectedDates, setSelectedDates] = useState<{ from: Date; to: Date } | undefined>(undefined);
  const [searchText, setSearchText] = useState<string | undefined>(undefined);
  const [selectedRowIds, setSelectedRowIds] = useState<number[]>([]);
  const [selectedRowCardNumbers, setSelectedRowCardNumbers] = useState<string[]>([]);
  const [addressee, setAddressee] = useState<string | undefined>(undefined);
  const [isCroatian, setIsCroatian] = useState<boolean>(false);

  return (
    <ctxTachograph.Provider
      value={{
        tab,
        setTab,
        selectedDates,
        setSelectedDates,
        searchText,
        setSearchText,
        selectedRowIds,
        setSelectedRowIds,
        selectedRowCardNumbers,
        setSelectedRowCardNumbers,
        addressee,
        setAddressee,
        isCroatian,
        setIsCroatian,
      }}
    >
      {children}
    </ctxTachograph.Provider>
  );
}
